export { default as useCookies } from './useCookies';

export {
  useSelector,
  type HostState,
  type SideMenuNode,
  type MenuLink,
} from './common';

export { default as getMinimalStore } from './getMinimalStore';

export {
  useLocalize,
  useInvertedLocalize,
  type Localize,
  type InvertedLocalize,
} from './localization';

export {
  default as findAccessibleMenuLinks,
  type AccessibleMenuLink,
} from './findAccessibleMenuLinks';

export { default as Link } from './Link';

export { default as isEnumMember } from './isEnumMember';

export { type StateSetter } from './react';

export { default as renderWithProviders } from './renderWithProviders';

export { P, H2, H3, Label } from './typography';

export { default as mswDelayedRest } from './mswDelayedRest';

export const baseUrl = process.env.REACT_APP_NAV_API ?? '';
